import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FiLogIn, FiMail, FiLock, FiUser } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
// import logo from '../../assets/logo-compressed.png';

import { logo,eventName, supportNumber } from '../../config';
import { Container, Content, Background, AnimatedDiv2, ErrorDiv } from './styles';
import Input from '../../components/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';
import AreaExposicao from '../AreaExposicao';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import Logo from '../../components/Logo';
import { Pattern } from '../../styles/ThemeComponents';
import ShowDiv from '../../components/ShowOnScroll';
import Sponsors, { sponsors } from '../Sponsors';
import DivPopper from '../../components/DivPopper';
import Whatsapp from '../../components/Whatsapp';
import { useLanguage } from '../../hooks/Language';

interface SignInData {
  email: string;
  password: string;
  name: string;
}

const SignIn: React.FC = () => {
  const history = useHistory();
  const [withPassword, setWithPassword] = useState(false);
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const [ErrorMessage, setErrorMessage] = useState('');
const {translate} = useLanguage();
  const handleSubmit = useCallback(
    async (data: SignInData) => {
      try {
        formRef.current?.setErrors({});

        const shape = withPassword
          ? {
              email: Yup.string()
                .required('Email obrigatório')
                .email('Preencha um email válido'),
              password: Yup.string().required('Senha obrigatória'),
            }
          : {
              email: Yup.string()
                .required('Email obrigatório')
                .email('Preencha um email válido'),
            };

        const schema = Yup.object().shape(shape);

        await schema.validate(data, { abortEarly: false });

        const { email, name, password } = data;

        await signIn({ email, password, name });
        window.location.href = '/dashboard';
        return;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        setErrorMessage("Email não encontrado");


        }
        else{
          setErrorMessage("Email não encontrado");

        }

      
      }
    },
    [signIn, addToast, history],
  );

  return (<>
    <Container>
      <Content style={{maxWidth: '400px', alignItems: 'flex-start'}}>
        <AnimatedDiv2>
          <Form ref={formRef} onSubmit={handleSubmit}>
           <img src="/assets/evento/logo.png" style={{width: '100%', maxWidth: '450px'}}/>

           <Link to="/certificados" style={{ margin: '5px', marginBottom: '20px' }}>
            <Button >Visualizar certificados</Button>
          </Link>

            <h2>{translate('ACESSAR')}</h2>

            { ErrorMessage && <ErrorDiv> <span> {ErrorMessage} </span> <button type="button" onClick={() => setErrorMessage('')} className="errorButton"> X </button></ErrorDiv>}

            <Input icon={FiMail} name="email" placeholder={translate('E-mail')} />
            {withPassword && (
              <Input
                icon={FiLock}
                name="password"
                type="password"
                placeholder={translate('senha')}
              />
            )}
            <Button type="submit" style={{ width: '100%' }}>
              {translate('Entrar')}
            </Button>
            <Whatsapp number={supportNumber} text={`Estou no ${eventName}`} message="Suporte Técnico"/>
           
          </Form>
        </AnimatedDiv2>
      </Content>
<Content style={{maxWidth: '100%', width: '100%'}}>
<AreaExposicao idExpo={4} expoTitle="Patrocinadores Ouro"/>
<AreaExposicao idExpo={5} expoTitle="Patrocinadores Prata"/>
</Content>

    </Container>
   
    </>
        
  );
};
export default SignIn;
